export default "__VITE_ASSET__956f8a98__"